import { ApplicationState, FrontApplicationState } from '@flatsy/types/Applications/Status'
import { getLatestData } from '../Utils/GetLatestData'
import { WizardContext, WizardEvent } from '../wizardMachine'

export const isSuccess = (context: WizardContext, event: WizardEvent): boolean => {
  const { application } = getLatestData(context, event)

  return [FrontApplicationState.SUCCESS, FrontApplicationState.WAITING_LIST].includes(
    application?.computedState as FrontApplicationState
  )
}

export const isUnqualified = (context: WizardContext, event: WizardEvent): boolean => {
  const { application } = getLatestData(context, event)

  return (application?.state as ApplicationState) === ApplicationState.UNQUALIFIED
}

export const isBookingError = (context: WizardContext): boolean => {
  return context.bookingError
}
